const REDIRECT_TO = 'mcx-redirect-to-url';

export const setRedirectToUrl = (
  redirectTo = window.location.pathname.toString()
) => {
  sessionStorage.setItem(REDIRECT_TO, redirectTo);
};

export const getRedirectToUrl = () => {
  const redirectTo = sessionStorage.getItem(REDIRECT_TO);
  sessionStorage.removeItem(REDIRECT_TO);
  return redirectTo || '/';
};

export const getQueryStringOrPersistentProp = (key) => {
  const urlParams = new URLSearchParams(window.location.search);
  const queryValue = urlParams.get(key);
  if (queryValue) {
    return queryValue;
  }
  return sessionStorage.getItem(key);
};
